import Isotope from 'isotope-layout';

export default class FicheFilter {
    constructor(selector) {
        this.selector = selector;
        this.selectedCategories = [];
        this.query = '';

        if($(this.selector).length > 0) {
            // Init isotope
            this.isotope = new Isotope(this.selector, {
                itemSelector: '.fiche',
                layoutMode: 'fitRows'
            });

            // Bind events
            $(".filter-isotope").click(ev => this.changeCategory(ev.target));
            $(".search-box").keyup(ev => this.changeQuery(ev.target.value));
        }
    }

    changeQuery(text) {
        this.query = text;
        this.filter();
    }

    changeCategory({innerText: category, classList}) {
        if (this.selectedCategories.includes(category)) {
            classList.remove("active");
            this.selectedCategories.splice(this.selectedCategories.indexOf(category), 1)
        } else {
            classList.add("active")
            this.selectedCategories.push(category)
        }

        this.filter()
    }

    textFilter(item) {
        const itemCategories = $(item).children('.card').data('categories').toLocaleLowerCase();
        const itemContent = $(item).children('.card').data('content').toLocaleLowerCase();
        const itemText = $(item).find('.card-title a').text().toLocaleLowerCase();

        return (
            itemCategories.includes(this.query.toLocaleLowerCase()) ||
            itemContent.includes(this.query.toLocaleLowerCase())||
            itemText.includes(this.query.toLocaleLowerCase())
        );
    }

    filter() {
        this.isotope.arrange({
            filter: (index, itemElem) => {
                const matchesSearch = this.textFilter(itemElem);
                const matchesCategories = this.selectedCategories
                    .every(category =>
                        $(itemElem).children('.card').data('categories').split(',').includes(category)
                    );


                return (!this.query || matchesSearch) && (!this.selectedCategories.length || matchesCategories);
            }
        });
    }


}